import pb from './pb';
import type { Promotion } from '../types/promotion';

export async function fetchActivePromotion(): Promise<Promotion | null> {
  const now = new Date().toISOString().replace('T', ' ');
  try {
    return await pb
      .collection('promotions')
      .getFirstListItem<Promotion>(`start_time <= "${now}" && end_time >= "${now}"`, {
        sort: 'start_time',
      });
  } catch {
    // No matching record found (404) — return null
    return null;
  }
}

export function getPromotionImageUrl(promotion: Promotion): string {
  if (!promotion.image) return '';
  return `${pb.baseURL}/api/files/promotions/${promotion.id}/${promotion.image}`;
}
